import styled, { createGlobalStyle } from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

// Light hero for /alternatives pages that opt in with heroVariant: "light".
// Header rules mirror widgetHeroLight so the nav matches the widget pages.
export const StyledAlternativesHeroLight = styled.section`
	text-align: center;
	overflow: hidden;
	background: linear-gradient(180deg, ${CSSVars.white} 0%, ${CSSVars.blue50} 100%);
	color: ${CSSVars.black};
	padding: 10px 0 0;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 20px 0 0;
	}

	header.fix-position,
	header.fix-position.light-mode {
		background: transparent;
		box-shadow: none;
		filter: none;
		padding: 0 0 15px;
		border-bottom: 1px solid #e0e0e0;
		border-radius: 0;
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		top: 0;
		left: 0;

		@media screen and (max-width: ${CSSVars.breakpointXL}) {
			padding: 0 20px 15px;
		}
	}

	.hero-wrapper {
		padding: 60px 20px 60px;
		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 90px 40px 90px;
		}

		h1 {
			font-size: ${CSSVars.fontSize2XL};
			font-weight: 600;
			line-height: 1.25;
			max-width: 980px;
			margin: 0 auto 20px;
			text-wrap: balance;

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				font-size: ${CSSVars.fontSize3XL};
			}
		}

		h2 {
			margin: 0 auto;
			font-size: ${CSSVars.fontSizeLG};
			font-weight: 300;
			line-height: 1.5;
			max-width: 680px;
			color: ${CSSVars.gray700};
			text-wrap: balance;
		}

		.updated-label {
			margin: 16px 0 0;
			font-size: ${CSSVars.fontSizeSM};
			color: ${CSSVars.gray500};
		}

		a {
			margin: 36px auto 0;
		}
	}
`;

// The (content) layout renders its own dark Header, absolute at the top of the page.
// On a light hero it bleeds through, so hide it while at the top; once the visitor
// scrolls it drops the in-on-top class and shows as the usual sticky header.
export const HideLayoutTopHeader = createGlobalStyle`
	header.in-on-top:not(.fix-position) {
		visibility: hidden;
	}
`;
